import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form';
import AdpDriverPortalForm from './AdpDriverPortalForm';

const InitiateAdpForm = ({ location, match }) => {
  const { state } = location || {};
  const { isAdminForm } = state || {};
  let draftApp;
  if (match?.params?.id) {
    draftApp = match?.params?.id;
  }
  return (
    <div>
      {isAdminForm ? (
        <AdpDriverPortalForm draftApp={draftApp} />
      ) : (
        <Form />
      )}
    </div>
  );
};

InitiateAdpForm.propTypes = {
  location: PropTypes.shape({}).isRequired
};

export default InitiateAdpForm;
